module.exports = __webpack_public_path__ + "img/sla.3363755.svg";